import * as React from 'react'

import { useStoreViews } from '@emico/storeviews'

import ProductCanonical from './ProductCanonical'

interface Props {
    id: number
}

const ProductCanonicals = ({ id }: Props) => {
    const storeViews = useStoreViews()

    return (
        <>
            {storeViews.map((storeView) => (
                <ProductCanonical
                    key={storeView.code}
                    storeView={storeView}
                    urlId={id}
                />
            ))}
        </>
    )
}

export default ProductCanonicals
